import { encodeUuidForUrl } from './compact-uuid';

export const ROUTES = {
  login: '/login',
  analytics: {
    wordstat: '/wordstat',
    wordstatDetailPattern: '/wordstat/:id',
    wordstatDetail: (id: string) => `/wordstat/${encodeUuidForUrl(id)}`,
    dynamics: '/dynamics',
    serpset: '/serpset',
  },
  tasks: {
    wordstat: '/wordstat-tasks',
    wordstatNew: '/wordstat-tasks/new',
    wordstatDetailPattern: '/wordstat-tasks/:id',
    wordstatDetail: (id: string) => `/wordstat-tasks/${encodeUuidForUrl(id)}`,
    overview: '/monitoring',
    baskets: '/baskets',
    targets: '/targets',
    basketDetailPattern: '/baskets/:id',
    basketDetail: (id: string) => `/baskets/${encodeUuidForUrl(id)}`,
    connections: '/credentials',
    oneTime: '/experiments',
    oneTimeNew: '/experiments/new',
    oneTimeDetailPattern: '/experiments/:id',
    oneTimeDetail: (id: string) => `/experiments/${encodeUuidForUrl(id)}`,
    recurring: '/crons',
    recurringNew: '/crons/new',
    recurringDetailPattern: '/crons/:id',
    recurringDetail: (id: string) => `/crons/${encodeUuidForUrl(id)}`,
  },
} as const;
